module.exports = __webpack_public_path__ + "media/title_mob_3.0cdad07d.mp4";